import axios from 'axios';

// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: '', // Use relative paths for .NET integration
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add auth token to requests and handle JSON stringification
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      // Get token from localStorage (maintaining compatibility with existing auth)
      const encodedToken = localStorage.getItem('_Host_Pro_Hckare_TKN');
      if (encodedToken) {
        const token = window.atob(encodedToken);
        config.headers.Authorization = `Bearer ${token}`;
      }
      
      // Handle pre-stringified JSON data from legacy code
      // If data is already a JSON string, parse it back to object for axios to handle
      if (typeof config.data === 'string' && config.data.length > 0) {
        try {
          config.data = JSON.parse(config.data);
        } catch (e) {
          // If parsing fails, it's not JSON, leave it as is
        }
      }
    } catch (error) {
      console.error('Error in request interceptor:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;
      
      switch (status) {
        case 401:
          // Unauthorized - clear auth and redirect to login
          localStorage.removeItem('ajs_user_id');
          localStorage.removeItem('_Host_Pro_Hckare_TKN');
          localStorage.removeItem('_Host_Pro_type');
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
          break;
          
        case 403:
          // Forbidden
          console.error('Access forbidden:', data);
          break;
          
        case 404:
          // Not found
          console.error('Resource not found:', error.config.url);
          break;
          
        case 500:
          // Server error
          console.error('Server error:', data);
          break;
          
        default:
          console.error('API error:', status, data);
      }
    } else if (error.request) {
      // Request made but no response
      console.error('Network error - no response received');
    } else {
      // Error setting up request
      console.error('Request setup error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Helper function for FormData requests
export const createFormDataRequest = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    if (data[key] !== null && data[key] !== undefined) {
      formData.append(key, data[key]);
    }
  });
  return formData;
};

// Helper for query string parameters
export const buildQueryString = (params) => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined) {
      searchParams.append(key, params[key]);
    }
  });
  return searchParams.toString();
};

export default axiosInstance;
